import { render } from "./CollectionListingsChart.vue?vue&type=template&id=3bd3cb9e"
import script from "./CollectionListingsChart.vue?vue&type=script&lang=js"
export * from "./CollectionListingsChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__